import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import { PROTECTED_ROUTES } from "../routes";
import ScrollToTop from "components/ScrollToTop";
import AdminShell from "components/AdminShell";

// useRoutes() must run *inside* the Router, so the routed content is its own
// component: AppWrapper renders the Router that provides the context.
const ProtectedRoutes = () => {
  const routes = useRoutes(PROTECTED_ROUTES);
  return routes;
};

const AppWrapper = () => (
  <Router>
    <ScrollToTop />
    <AdminShell>
      <ProtectedRoutes />
    </AdminShell>
  </Router>
);
export default AppWrapper;
